import * as React from "react";
import {cx} from "emotion";

import "./headshot-card.scss";

import {OnMounted} from "@Common/react/on-mounted";
import {Types}     from "@Common/types";
import {isDevQuan} from "@Common/ui-components/debug/is-dev-quan";

import {formatImageSize} from "../../format-image-size";
import {ClearableSelect} from "../../image-asset-edit-modal/clearable-select/clearable-select";

type HS = Types.Xpresso.Account.Common.HeadshotsPanel.Headshot;

export const HeadshotCard = ({
    headshot,
    onEdit,
    onDelete,
    onUIDefaultChange : emitUIDefaultChange,
}: {
    headshot            : HS,
    onEdit             ?: () => any,
    onDelete           ?: (modal:any) => any,
    onUIDefaultChange  ?: (slot:number) => void,
}) => ({
    defaultSlot: headshot.defaultSlot,
    render: () => (
        <div
            className="headshot-card"
            key={headshot.id}
            xd-qa-type="card"
            xd-qa-name={`${headshot.name}.${headshot.fileType}`}
        >
            {/*{isDevQuan() && (*/}
            {/*    OnMounted({*/}
            {/*        action: () => onEdit(),*/}
            {/*    })*/}
            {/*)}*/}
            <div className="headshot">
                <div className="img-box">
                    <img
                        className="image"
                        src={headshot.thumbnailUrl}
                        alt={headshot.name + "." + headshot.fileType}
                        xd-qa-name="headshot"
                        xd-qa-type="image"
                    />
                </div>
                {headshot.defaultSlot > 0 && (
                    <div
                        className="default"
                        xd-qa-name="Default"
                        xd-qa-type="label"
                    >
                        {"Headshot " + headshot.defaultSlot}
                    </div>
                )}
            </div>
            <div className="details">
                <header>
                    <div className="info">
                        <div
                            className="file-name"
                            xd-qa-name="File Name"
                            xd-qa-type="label"
                            title={headshot.name + "." + headshot.fileType}
                        >
                            {headshot.name + "." + headshot.fileType}
                        </div>
                        <div
                            className="file-size"
                            xd-qa-name="File Size"
                            xd-qa-type="label"
                        >
                            {formatImageSize(headshot.fileSize)}
                        </div>
                    </div>
                    <div
                        className={cx("quality", {
                            high: headshot.quality === "High",
                            medium: headshot.quality === "Medium",
                            low: headshot.quality === "Low",
                        })}
                        xd-qa-name="Quality"
                        xd-qa-type="label"
                    >
                        {headshot.quality}
                    </div>
                </header>

                {onEdit && <div className="edit-delete">
                    <button
                        className="edit"
                        xd-qa-type="link"
                        xd-qa-name="Edit"
                        onClick={onEdit}
                    >
                        Edit
                    </button>
                    <div className="line"/>
                    <button
                        className="delete"
                        xd-qa-type="link"
                        xd-qa-name="Delete"
                        onClick={onDelete}
                    >
                        Delete
                    </button>
                </div>}

                {emitUIDefaultChange && (
                    <div className="default-slot-select">
                        <ClearableSelect<number> {...{
                            list            : [1, 2],
                            isSelected      : (slot) => headshot.defaultSlot === slot,
                            onClear         : ()     => 0    !== headshot.defaultSlot && emitUIDefaultChange(0),
                            onSelect        : (slot) => slot !== headshot.defaultSlot && emitUIDefaultChange(slot),

                            getExpandLabel  : (slot) => `Headshot #${slot}`,
                            getToggleLabel  : (slot) => `Headshot #${slot}`,

                            placeholder     : "Make Default",
                            xdQaName        : "Make Default",
                        }}/>
                    </div>
                )}
            </div>
        </div>
    ),
});
